import { Injectable } from '@angular/core';
import { BookingStatusEnum } from '@shared/booking-feature';
import { BaseMapper } from '@shared/data';
import { BookingResponseDto } from '../dto/booking-response.dto';
import { BookingModel } from '../model/booking.model';

@Injectable({
    providedIn: 'root',
})
export class BookingMapper extends BaseMapper<BookingModel, BookingResponseDto> {
    public mapDtoToModel(dto: BookingResponseDto): BookingModel {
        return {
            id: dto.id,
            status: dto.status as BookingStatusEnum,
            caseId: dto.caseId,
            externalId: dto.externalId,
            isTelemedicine: dto.isTelemedicine,
            createdAt: this.stringDateToDayjs(dto.createdAt),
            updatedAt: this.stringDateToDayjs(dto.updatedAt),
        };
    }
}
